exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".result-header{max-width:580px;margin:0 auto;text-align:center;position:relative;font-family:Hiragino Kaku Gothic Pro}.result-header__back{position:absolute;left:15px;text-decoration:none}.result-header__back span{line-height:12px;font-size:12px;color:#000;display:inline-block;padding:17px 0;margin-left:7px}.result-header__back:before{content:\"\";width:8px;height:14px;background-image:url(\"/static/img/common/arrow_left_black.svg\");background-size:contain;background-repeat:no-repeat;display:inline-block;position:relative;top:3px}.result-header__title{padding:16px 0;display:inline-block;line-height:14px;font-size:14px;color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-82ffbc4a","scoped":false,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/ResultHeader.vue
// module id = 51mV
// module chunks = 0